import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import sample_company from '../../Assets/icons/sample_company.jpg';
import { addToWishlist, removeFromWishlist } from "../../utils/CandidateUtilityFunctions";

const JobCard = ({ job, isInWishlist }) => {
  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");
  const userType = localStorage.getItem("userType");
  const [isWishlisted, setIsWishlisted] = useState(isInWishlist(job.job_id));

  useEffect(() => {
    setIsWishlisted(isInWishlist(job.job_id));
  }, [isInWishlist, job.job_id]);

  const toggleWishlist = async (e) => {
    e.stopPropagation();

    if (!userid) return; 

    try {
      if (isWishlisted) {
        await removeFromWishlist(job.job_id, userid);
      } else {
        await addToWishlist(job.job_id, userid);
      }
      setIsWishlisted(!isWishlisted); 
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  return (
      <div className="col-lg-6 d-flex">
        <div className="job-item d-flex flex-column w-100">
          <div className="job-search-item cursor-pointer">
          {userid && userType === "candidate" ? (
            <p className="job-bookmark">
              <i
                className={isWishlisted ? "fas fa-check text-success fs-4" : "fe-bookmark"}
                onClick={toggleWishlist}
              />
            </p>
          ) : null}

            <div className="job-top">
              <div className="job-img" onClick={() => navigate(`employers/employer-details/${job.company_id}`)}>              
                <img
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"
                src={job.company_logo ? `${process.env.REACT_APP_API_URL}${job.company_logo}` : sample_company}  alt="Default Company Logo" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = sample_company;
                }} />
              </div>
              <div className="job-title">
                <h5>
                  <Link to={`/job-details/${job.job_id}`}>{job.job_name}</Link>
                </h5>
                <Link to={`employers/employer-details/${job.company_id}`} className="job-employer">
                  <i className="far fa-building" /> {job.company_name}
                </Link>
              </div>
            </div>
            <div className="job-content">
              <ul className="job-info-list">
                <li>
                  <i className="fe-briefcase" /> {job.experience}
                </li>
                <li>
                <i className="fa-light fa-sack-dollar" /> {job.package ? job.package : "Not Available"}
                  {/* <i className="fa-light fa-file-invoice-dollar" /> {job.package ? job.package : "Not Available"} */}
                  {/* <i className="fa-solid fa-indian-rupee-sign" /> {job.package ? job.package : "Not Available"} */}
                  {/* <i className="bi bi-check-circle" /> {job.package ? job.package : "Not Available"} */}
                </li>
                {/* <li>
                <i className="fe-clock" /> {new Date(job.post_date).toLocaleDateString()}
              </li> */}
                <li>
                  <i className="fe-map-pin" /> {job.city}
                </li>
              </ul>
            <div className="job-skill">
              {job.skills ? (() => {
                let skillsArray = [];
                if (typeof job.skills === "string") {
                  try {
                    const parsed = JSON.parse(job.skills);
                    skillsArray = Array.isArray(parsed) ? parsed : [];
                  } catch (err) {
                    console.error("Invalid JSON in job.skills:", err);
                    return <p>Invalid skill data</p>;
                  }
                } else if (Array.isArray(job.skills)) {
                  skillsArray = job.skills;
                }

                return skillsArray.length > 0 ? (
                  skillsArray.map((skill, index) => (
                    <Link to="#" className="m-1 badge badge-secondary" key={index}>
                      {skill.skill_name}
                    </Link>
                  ))
                ) : (
                  <p>No skills available</p>
                );
              })() : (
                <p>No skills available</p>
              )}
            </div>

          </div>
          </div>
          <div className="mt-auto job-bottom justify-content-end">
            <Link className="theme-btn" to={`/job-details/${job.job_id}`}>
              View Details
            </Link>
          </div>
        </div>
      </div>
  );
};

export default React.memo(JobCard);
